/**
 * Resolves the DOM tree an element is rendered in: the widget's `ShadowRoot` (`<calenso-booking>`
 * renders inside an open shadow root), otherwise the `document` (e.g. a detached element).
 *
 * Use it instead of `document.getElementById()` / `document.querySelector()` for elements the
 * widget renders itself — inside a shadow tree those are unreachable from `document`.
 */
export function getDomRoot(element: Element | null | undefined): Document | ShadowRoot {
  const root = element?.getRootNode();
  return typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot ? root : document;
}
